import React from "react";

import YouTube from "react-youtube";

import General from "../../utils/General";
import PortalModal from "./PortalModal";
import VideoPlayer from "../common/VideoPlayer";

export default class VideoModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      videoUrl: props.videoUrl,
      videoSource: props.videoSource,
      isLoading: false,
      showModal: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  render() {
    const { videoUrl, videoSource, showModal } = this.state;

    const videoId = General.getYoutubeVideoId(videoUrl);

    return (
      <PortalModal
        show={showModal}
        showAsSideMenu="false"
        contentSuperContainerClassName={`bg-dark yt-video-lg`}
        contentContainerClassName=""
        onHide={() => this.props.onHide()}
      >
        <div className={"yt-video-container"}>
          <VideoPlayer
            videoUrl={videoUrl}
            videoSource={videoSource}
            pubCode={this.props.pubCode}
          />
        </div>
      </PortalModal>
    );
  }
}
